import React from 'react'
import i18n from '@pureartisan/simple-i18n'
import clsx from 'clsx'
import shallow from 'zustand/shallow'
import { makeStyles } from '@material-ui/core/styles'
import { IconButton } from '@material-ui/core'
import useStore from '../store'
import { BsQuestion } from 'react-icons/bs'

const styles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    right: '16px',
    bottom: '22px',
    padding: 0,
    backgroundColor: theme.extras.variables.colors.ddkNavy,
    color: '#fff',
    display: 'block',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
    '&:hover': {
      backgroundColor:
        theme.extras.variables.colors.ddkNavy,
    },
  },
}))

const MobileFaqBtn = () => {
  const { setStoreValues } = useStore(
    state => ({
      setStoreValues: state.setStoreValues,
      slideoutPanel: state.slideoutPanel,
    }),
    shallow,
  )

  const openFaqs = e => {
    e.preventDefault()
    setStoreValues({
      slideoutPanel: {
        active: true,
        panel: 'faq',
      },
    })
  }

  const classes = styles()

  return (
    <IconButton
      label={i18n.translate(`CONTROL_PANEL_FAQS`)}
      onClick={openFaqs}
      className={clsx('map-faqs-mobile', classes.root)}
    >
      <BsQuestion fontSize={48} />
    </IconButton>
  )
}

export default MobileFaqBtn
